module.exports = __webpack_public_path__ + "static/media/sponsor__twitch--color.a1fd3e5d.png";